import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { Observable } from 'rxjs';
import { FlashMessagesService } from "angular2-flash-messages";

export interface DialogData {
  storeId: string;
  orderId: string;
}

@Component({
  selector: 'app-customer-notification',
  templateUrl: './customer-notification.component.html',
  styleUrls: ['./customer-notification.component.css']
})
export class CustomerNotificationComponent implements OnInit {

  @ViewChild('msg') msg: ElementRef;
  public loading = false;
  customerNotification: FormGroup;
  isActive = 'no';
  userList: Array<any> = [];
  searchTextboxControl = new FormControl();
  filteredOptions: Observable<any[]>;
  public isShowError = false;  
  public emailTags: Array<any> = [
    { value: "", viewValue: "Select Tag add in email message" },
    { value: "{{order_url}}", viewValue: "Order URL" },
    { value: "{{order_id}}", viewValue: "Order Id" }
  ];
  public selectedEmailTags = '';
  public defaultSubject = '';
  public defaultMessage = '';
  public selectedStatus = 'pickup';
  public defaultSubjects = {
    pickup: '#{{order_id}} is ready for pickup',
    shipped: '#{{order_id}} has been shipped',
  };
  public defaultMessages = {
    pickup: 'Your order is ready for pickup. If we are shipping them to you, then they are on their way. {{order_url}}',
    shipped: 'Your order has been shipped. They are on their way. {{order_url}}',
  };

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<CustomerNotificationComponent>,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
    this.defaultSubject = this.defaultSubjects.pickup;
    this.defaultMessage = this.defaultMessages.pickup;
    this.customerNotification = this.formBuilder.group({
      subject: [this.defaultSubject, Validators.required],
      message: [this.defaultMessage, Validators.required],
    });
  }
  isFieldValid(field: string) {
    return (
      !this.customerNotification.get(field).valid &&
      this.customerNotification.get(field).touched
    );
  }
  onSubmit(postData) {
    this.dialogRef.close(postData);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  sendNotification = function (postData) {
    this.loading = true;
    let mailoption = {
      id: localStorage.getItem("userID"),
      storeId: this.data.storeId,
      orderId: this.data.orderId,
      subject: postData.subject,
      message: postData.message
    };
    this.CommonService.apiService(
      "POST",
      "store/customer/notification",
      mailoption
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 2000
          });
          setTimeout(() => {
            this.dialogRef.close();
          }, 2500);
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  }

  onEmailTagChange(emailTagValue) {
    if (emailTagValue != '') {
      let startPos = this.msg.nativeElement.selectionStart;
      this.msg.nativeElement.focus();
      this.customerNotification.get('message').patchValue(this.msg.nativeElement.value.substr(0, this.msg.nativeElement.selectionStart) + emailTagValue + this.msg.nativeElement.value.substr(this.msg.nativeElement.selectionStart, this.msg.nativeElement.value.length));
      //this.msg.nativeElement.value = this.msg.nativeElement.value.substr(0, this.msg.nativeElement.selectionStart) + emailTagValue + this.msg.nativeElement.value.substr(this.msg.nativeElement.selectionStart, this.msg.nativeElement.value.length);
      this.msg.nativeElement.selectionStart = startPos;
      this.msg.nativeElement.focus();
    }
  }

  onStatusChange(status: string) {
    this.customerNotification.get('subject').patchValue(this.defaultSubjects[status]);
    this.customerNotification.get('message').patchValue(this.defaultMessages[status]);
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/customer-notification/customer-notification.component.ts